import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ProductSaleUpdateForm from './ProductSaleUpdateForm';
import MaterialSaleUpdateForm from './material-sales/MaterialSaleUpdateForm';
import SparepartSaleUpdateForm from './sparepart-sales/SparepartSaleUpdateForm';

const SaleUpdateForm = ({ show, handleClose }) => {
    const { sale } = useSelector(state => state.sale);
    const [selectedType, setSelectedType] = useState('product');

    useEffect(() => {
        if (sale) {
            setSelectedType(sale.type || 'product');
        }
    }, [sale]);

    const handleTypeSelect = (type) => {
        setSelectedType(type);
    };

    if (!show || !sale) return null;

    const getModalTitle = () => {
        switch (selectedType) {
            case 'product':
                return 'Mahsulot sotuvini tahrirlash';
            case 'material':
                return 'Material sotuvini tahrirlash';
            case 'sparepart':
                return 'Ehtiyot qism sotuvini tahrirlash';
            default:
                return 'Sotuvni tahrirlash';
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {getModalTitle()}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4 d-flex justify-content-center">
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="productSale"
                        label="Mahsulot sotuvi"
                        checked={selectedType === 'product'}
                        onChange={() => handleTypeSelect('product')}
                        disabled={true}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="materialSale"
                        label="Material sotuvi"
                        checked={selectedType === 'material'}
                        onChange={() => handleTypeSelect('material')}
                        disabled={true}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        name="saleType"
                        id="sparepartSale"
                        label="Ehtiyot qism sotuvi"
                        checked={selectedType === 'sparepart'}
                        onChange={() => handleTypeSelect('sparepart')}
                        disabled={true}
                    />
                </div>
                {selectedType === 'product' ? (
                    <ProductSaleUpdateForm show={show} handleClose={handleClose} />
                ) : selectedType === 'material' ? (
                    <MaterialSaleUpdateForm show={show} handleClose={handleClose} />
                ) : (
                    <SparepartSaleUpdateForm show={show} handleClose={handleClose} />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SaleUpdateForm;